import CommonModal from "@components/ui-components/modal";
import FormView from "@components/views/form-view";
import InputField from "@components/fields/input-field";
import { Row } from "reactstrap";
import size from "lodash/size";
import useUpsert from "./use-upsert";

const UpsertTemplates = props => {
    const { modalConfig, handleModal } = props;
    const isEdit = !!size(modalConfig.row);

    const { onSubmit, methods, updateLoading, isDirty } = useUpsert(props);
    const {
        control,
        formState: { errors }
    } = methods;

    const content = [
        {
            leftChild: {
                title: "Enter Basic Details",
                desc : "Enter the basic details of the templates which you wish to create"
            },
            rightChild: (
                <Row>
                    <InputField
                        id="title"
                        name="title"
                        label="Title"
                        required
                        control={control}
                        errors={errors}/>

                    <InputField
                        type="textarea"
                        id="content"
                        rows={5}
                        name="content"
                        label="Content"
                        required
                        control={control}
                        errors={errors}/>
                </Row>
            )
        }
    ];

    return (
        <CommonModal
            title={`${isEdit ? "Edit" : "Add"} Template`}
            body={<FormView content={content} />}
            confirmButton={{
                txt    : isEdit ? "Update" : "Add",
                icon   : "content-save",
                onClick: onSubmit
            }}
            type="extraLarge"
            isDirty={isDirty}
            loading={updateLoading}
            handleModal={handleModal}
            isOpen={modalConfig.isOpen}/>
    );
};

export default UpsertTemplates;
